export default __webpack_public_path__ + "static/media/francheville08.d489bb11.jpg";